import React from 'react';

import { Button, Divider, Group } from '@mantine/core';
import { IconArrowLeft, IconArrowRight, IconX } from '@tabler/icons-react';

import { useCancelModal } from '../../CancelModalContext';

const WizardFooter: React.FC = () => {
  const {
    isFirstStep,
    isLastStep,
    goNext,
    goBack,
    submit,
    handleClose,
    cancelMutation,
    currentStep,
    isLoadingReservations,
  } = useCancelModal();

  const isSubmitting = cancelMutation.isLoading;
  const isWaitingForReservations = currentStep === 'Cancellation Settings' && isLoadingReservations;

  return (
    <>
      <Divider />
      <Group position='apart' pt='sm'>
        {isFirstStep ? (
          <Button
            variant='subtle'
            color='gray'
            size='xs'
            radius='md'
            leftIcon={<IconX size={13} />}
            onClick={handleClose}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
        ) : (
          <Button
            variant='subtle'
            color='gray'
            size='xs'
            radius='md'
            leftIcon={<IconArrowLeft size={13} />}
            onClick={goBack}
            disabled={isSubmitting}
          >
            Back
          </Button>
        )}

        {isLastStep ? (
          <Button size='xs' radius='md' color='red' onClick={submit} loading={isSubmitting}>
            End Package
          </Button>
        ) : (
          <Button
            size='xs'
            radius='md'
            rightIcon={<IconArrowRight size={13} />}
            onClick={goNext}
            disabled={isSubmitting}
            loading={isWaitingForReservations}
          >
            Next
          </Button>
        )}
      </Group>
    </>
  );
};

export default WizardFooter;
